var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEGeneralOutsideTemperatureSensor = function SvgEGeneralOutsideTemperatureSensor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 522,
    y: 32,
    width: 28,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549,33v26h-26v-26h26M550,32h-28v28h28v-28h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 538.74,
    y: 34.69,
    width: 3.88,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.74,
    y: 37.81,
    width: 3.05,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.74,
    y: 40.93,
    width: 3.88,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.74,
    y: 44.06,
    width: 3.05,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.74,
    y: 47.18,
    width: 3.88,
    height: 0.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "531.39 40.34 531.39 40.18 531.34 40.15 531.39 40.34",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.96,49.22v-13.78h-3.82v13.78c-1.2.67-2.01,1.96-2.01,3.43,0,2.16,1.76,3.92,3.92,3.92s3.92-1.76,3.92-3.92c0-1.47-.81-2.75-2.01-3.43h0ZM534.05,55.42c-1.54,0-2.78-1.25-2.78-2.78,0-1.11.65-2.06,1.59-2.51v-5.61h2.39v5.61c.94.45,1.59,1.4,1.59,2.51,0,1.54-1.25,2.78-2.78,2.78h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.25,50.13v-5.61h-2.39v5.61c-.94.45-1.59,1.4-1.59,2.51,0,1.54,1.25,2.78,2.78,2.78s2.78-1.25,2.78-2.78c0-1.11-.65-2.06-1.59-2.51ZM535.42,54l-.53-.53c.23-.23.35-.52.35-.84s-.12-.62-.35-.84l.53-.53c.37.37.57.85.57,1.37s-.2,1.01-.57,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.71,48.8v-14.11h-5.32v14.11c-1.22.84-2.01,2.25-2.01,3.84,0,2.58,2.09,4.67,4.67,4.67s4.67-2.09,4.67-4.67c0-1.59-.8-3-2.01-3.84h0ZM534.05,56.57c-2.16,0-3.92-1.76-3.92-3.92,0-1.47.81-2.75,2.01-3.43v-13.78h3.82v13.78c1.2.67,2.01,1.95,2.01,3.43,0,2.16-1.76,3.92-3.92,3.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.89,51.79c.23.23.35.52.35.84s-.12.62-.35.84l.53.53c.37-.37.57-.85.57-1.37s-.2-1.01-.57-1.37l-.53.53Z",
    fill: "#fff"
  })))))));
};
export default SvgEGeneralOutsideTemperatureSensor;